@if (isVisible()) {
  <!-- Overlay -->
  @if (isOpen()) {
    <div class="gpt-assistant-overlay" (click)="closeAssistant()"></div>
  }

  <!-- Botón flotante del asistente -->
  <button 
    class="gpt-assistant-button"
    [class.open]="isOpen()"
    (click)="toggleAssistant()"
    [title]="isOpen() ? 'Cerrar asistente' : 'Abrir asistente'">
    @if (isOpen()) {
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    } @else {
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    }
  </button>

  <!-- Panel del asistente -->
  @if (isOpen()) {
    <div class="gpt-assistant-panel">
      <div class="gpt-assistant-header">
        <div class="gpt-assistant-title">
          <div class="gpt-assistant-avatar">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
          </div>
          <div>
            <h3>Asistente Educativo</h3>
            <p class="gpt-assistant-subtitle">¿En qué puedo ayudarte?</p>
          </div>
        </div>
        <div class="gpt-assistant-actions">
          <button 
            class="gpt-action-btn"
            (click)="clearConversation()"
            title="Limpiar conversación">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
          </button>
          <button 
            class="gpt-action-btn"
            (click)="closeAssistant()"
            title="Cerrar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="gpt-chat-messages" #messagesContainer>
        @if (messages().length === 0) {
          <div class="gpt-empty-state">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            <p>Inicia una conversación con tu asistente</p>
          </div>
        } @else {
          @for (message of messages(); track $index) {
            <div 
              class="gpt-message" 
              [class.user]="message.role === 'user'" 
              [class.assistant]="message.role === 'assistant'"
              [class.new-message]="message.isNew">
              <div class="gpt-message-content">
                @if (message.role === 'assistant') {
                  <div class="gpt-message-text" [innerHTML]="parseMarkdown(message.content)"></div>
                } @else {
                  <p>{{ message.content }}</p>
                }
                <span class="gpt-message-time">{{ formatTime(message.timestamp) }}</span>
              </div>
            </div>
          }
        }

        @if (isLoading()) {
          <div class="gpt-message assistant">
            <div class="gpt-message-content">
              <div class="gpt-typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        }

        @if (error()) {
          <div class="gpt-error-message">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <p>{{ error() }}</p>
          </div>
        }
      </div>

      <div class="gpt-chat-input">
        <textarea
          [(ngModel)]="messageValue"
          (keydown)="onKeyPress($event)"
          placeholder="Escribe tu pregunta aquí..."
          [disabled]="isLoading()"
          rows="1"
          class="gpt-input-field">
        </textarea>
        <button 
          class="gpt-send-button"
          (click)="sendMessage()"
          [disabled]="!currentMessage.trim() || isLoading()">
          @if (isLoading()) {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" stroke-opacity="0.25"/>
              <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke-opacity="0.75"/>
            </svg>
          } @else {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="22" y1="2" x2="11" y2="13"/>
              <polygon points="22 2 15 22 11 13 2 9 22 2"/>
            </svg>
          }
        </button>
      </div>
    </div>
  }
}
